export default "__VITE_ASSET__68478e10__"